import React from 'react';
import PropTypes from 'prop-types';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import ManagePaymentsSME from './ManagePaymentsSME';
import ManagePaymentNew from './ManagePaymentNew';
import { BioCatchContext } from '../BioCatchContext';
import { VIEW_PAYMENT_DETAILS_CONTEXT } from '../../config/BioCatch';
import envConfig from '../../../static/config';

export const ManagePaymentsLandingPage = ({
  isSMEUser = false,
  content,
  session,
  ...props
}) => {
  return (
    <BioCatchContext context={VIEW_PAYMENT_DETAILS_CONTEXT}>
      {isSMEUser ? (
        <ManagePaymentsSME
          content={content}
          envConfig={envConfig}
          session={session}
          {...props}
        />
      ) : (
        <ManagePaymentNew
          content={content}
          isSMEUSER={isSMEUser}
          session={session}
          {...props}
        />
      )}
    </BioCatchContext>
  );
};

ManagePaymentsLandingPage.propTypes = {
  isSMEUser: PropTypes.bool.isRequired,
};

export default RequiresAuthenticatedUser(ManagePaymentsLandingPage);
